import { useBlocks } from "@/hooks/useContent";
import { t } from "@/lib/i18n";

export const ImportantNote = ({ className = "" }) => {
  const { data } = useBlocks();
  const block = data?.important_note;
  if (!block) return null;
  return (
    <aside className={`surface max-w-2xl p-5 text-sm leading-relaxed ${className}`} aria-label={t("common.importantNote")} data-testid="important-note">
      <p className="font-serif text-base font-semibold text-ink-900">{block.title || t("common.importantNote")}</p>
      <p className="mt-1.5 text-ink-900">{block.body}</p>
    </aside>
  );
};
